export default "__VITE_ASSET__B$DH3_5s__"